import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './about.styles.css';
import Profile from '../../assets/img/profile/profile.webp';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';

import Tilt from 'react-tilt';

const About = () => {
  return (
    <div id='about'>
      <div className='about'>
        <h1 className='pt-3 text-center font-details pb-3'>ABOUT ME</h1>
        <Container className='aboutsection'>
          <Row className='pt-3 pb-5 align-items-center'>
            <Col s={12} md={6}>
              <Row className='justify-content-center mb-2 mr-2 '>
                <Tilt options={{ max: 55 }}>
                  <Image
                    className='profile justify-content-end'
                    alt='profile'
                    src={Profile}
                    thumbnail
                    fluid
                  />
                </Tilt>
              </Row>
            </Col>
            <Col s={12} md={6} lg={6}>
              <Row className=' align-items-start p-2 my-details rounded'>
                Hi there! I am <strong>&nbsp;Ayush Tiwari</strong>
                <br />A passionate programmer, born and brought up in India. I
                am a Full Stack Web Developer with React.js, Express.js,
                Node.js, and MongoDB as my tech stack.
                <br />
                In 2019, I successfully completed my Graduation in Bachelor of
                Computer Appliction [BCA] from{' '}
                <a
                  href='https://www.dauniv.ac.in/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {' '}
                  'Devi Ahilya Vishwavidyalaya'
                </a>
                [Indore,India].
                <br />
                Currently, I am pursuing Master of Computer Application [MCA]
                from the same university.
                <br />
                My education background allowed me to thrive in this career and
                by taking trainings i enriched my skills more and more.
                <br />
                Working with the clients, my goal is always driven towards
                providing amazing experience with the best level of quality and
                service to them.
                <br />
                Along with that, I also help people as a COACH on their journey
                of becoming a professional programmer. I love learning about new
                technologies, what problems are they solving and How can I use
                them to build better and scalable products.
                <br /> <br />
                <Col className='d-flex justify-content-center flex-wrap'>
                  <div>
                    <a href='#contact'>
                      <Button className='m-2' variant='outline-primary'>
                        Let's talk
                      </Button>
                    </a>
                  </div>
                  <div>
                    {/* resume link https://drive.google.com/file/d/1fiNJSL0lQmN8st_YCX_RtyHmUty_da5x/view?usp=sharing */}
                    <a
                      href='https://drive.google.com/file/d/1KwuKGQsogQ0XaWEtOtlcRSsuwCMR352o/view?usp=sharing'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <Button className='m-2' variant='outline-success'>
                        My Resume
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a
                      href='https://github.com/ayushat'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <Button className='m-2' variant='outline-dark'>
                        GitHub
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a
                      href='https://www.instagram.com/ayush6282/'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <Button className='m-2' variant='outline-danger'>
                        Instagram
                      </Button>
                    </a>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
